export const IS_OPT_OUT_FORCED_TEXT = 'To comply with messaging regulations, adding the opt-out phrase in the message is enforced on the account level. If you wish to deactivate this feature, please contact us for assistance.'
